export default __webpack_public_path__ + "static/bny_full2-cf7400c8e07dca7b82153feb44f1feb1.png";